import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import BlockButton from 'components/UI/BlockButton';
import config from 'config/api';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
// import RegistrationForm from 'components/Registration/RegistrationTwoStepsForm';
import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import IconArrow from '@material-ui/icons/ArrowDropDown';
import Box from '@material-ui/core/Box';
import 'react-sticky-header/styles.css';
import HeaderMenu from './HeaderMenu';
import { menuColor } from 'helpers/colors';
import { fetchData } from '../../ducks/asyncFetcher';

import { isLoggedIn, getCurrentUserRole, getCurrentUserSubRole, getCurrentUser } from 'ducks/authentication';

const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      padding: '0 0 10px',
      [theme.breakpoints.only('md')]: {
        padding: '0 20px 20px',
      },
      '& .MuiButton-root.right': {
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: 'transparent',
      },
    },
    header: {
      minHeight: 150,
      [theme.breakpoints.down('xs')]: {
        minHeight: 200,
      },
    },
    padding: { padding: theme.spacing(2) },
    logo: {
      height: '100%',
      width: 296,
      cursor: 'pointer',
      backgroundImage: `url(${require('assets/images/' + process.env.REACT_APP_SITE + '/logo.png')})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      height: '100%',
      display: 'block',
      margin: '20px auto 10px 10px',
      backgroundPosition: 'bottom',
      [theme.breakpoints.down('sm')]: {
        backgroundPosition: 'center',
        margin: '10px auto',
      },
    },
    profileWrapper: {
      padding: 0,
      marginTop: '-40px',
    },
    profileButton: {
      fontSize: 13,
      padding: '5px 0',
      textAlign: 'center',
      display: 'block',
    },
    profileMenu: {
      '& .MuiButton-label': {
        color: theme.palette.primary.main,
      },
    },
    buttonMyAccount: {
      backgroundColor: 'transparent',
      fontWeight: 'bold',
      borderRadius: 'initial',
      color: menuColor || theme.palette.text.light,
      // height: 80,
      // padding: '8px 16px 8px',
      padding: '24px 16px 8px',
      height: 80,
      [theme.breakpoints.down('md')]: {
        padding: '8px 16px 8px',
        height: 'auto'
      },
      [theme.breakpoints.down('sm')]: {
        padding: 8,
        height: 50,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.selected': {
        color: theme.palette.text.primary,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      },
      marginLeft: 50,
      marginTop: 0,
      [theme.breakpoints.down('md')]: {
        marginLeft: 20,
        fontSize: 12,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
        marginRight: 10,
        marginLeft: 10,
        // marginBottom: 20,
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: 8,
      },

      '& .MuiButton-label': {
        padding: 0,
      },
      '&:after': {
        content: '" "',
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.primary.main,
        width: 0,
        height: 1,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
    },
    headerMenu: {
      textAlign: 'right',
      // borderBottom: '1px solid ' + (menuColor || '#fff'),
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        padding: 0,
        marginTop: 0,
        border: 'none',
      },
    },
    headerLogo: {
      height: 80,
    },
    headerContent: {
      textAlign: 'center',
      maxWidth: '60%',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      padding: 10,
      margin: '20px auto',
      [theme.breakpoints.down('sm')]: {
        padding: 20,
        maxWidth: '90%',
      },
    },
  };
};
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLogginIn: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this._gotoHome = this._gotoHome.bind(this);
    this._setIsLogginIn = this._setIsLogginIn.bind(this);
    this._onFormComplete = this._onFormComplete.bind(this);
  }

  _gotoHome() {
    this.props.history.push('/');
  }

  handleToggle = (e, url) => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClose = (event, url) => {
    this.setState({ isLogginIn: false });

    if (this.anchorEl.contains(event.target)) {
      return;
    }

    const { history } = this.props;
    this.setState({ open: false }, function () {
      // console.log('k', url)
      history.push(url);
    });
  };
  _setIsLogginIn = () => {
    this.setState({ isLogginIn: true });
  };
  _onFormComplete = () => {
    const { onLoggedIn } = this.props;
    this.setState({ isLogginIn: false }, () => {
      onLoggedIn();
    });
  };
  render() {
    const {
      // onPanelToggle,
      // userRole,
      current,
      headerImage,
      headerTitle,
      headerContent,
      isLoggedIn,
      condensed,
      $$user,
      classes,
      headerStyle,
      headerClass,
      // userSubRole
      // onRegistrationComplete,
    } = this.props;

    const { open, isLogginIn } = this.state;
    // console.log({isLogginIn})
    const menuSize = ['sm', 'xs'].indexOf(this.props.width) < 0 ? 40 : 28;

    const headerType = headerImage || void 0;

    let finalHeaderStyle = {};

    if (headerType) {
      finalHeaderStyle.backgroundPosition = '0 25%';
      finalHeaderStyle.backgroundSize = 'cover';
      finalHeaderStyle.backgroundRepeat = 'no-repeat';
      finalHeaderStyle.backgroundImage = `url(${require('assets/images/' +
        process.env.REACT_APP_SITE +
        '/header_' +
        headerType +
        '.jpg')})`;
    }

    const $$menu = config.getMenu($$user, { asImmutable: true });

    const $$profileMenu = config.getProfileMenu($$user, { asImmutable: true });

    const userRole = $$user !== undefined ? $$user.get('role') : undefined;
    const userSubRole = $$user !== undefined ? $$user.get('subRole') : undefined;
    // const logoMargin = ['sm', 'xs'].indexOf(this.props.width) < 0 ? '0 0 0 auto' : '30px auto 10px';
    // console.log({isLogginIn, userRole, userSubRole, $$user})
    return (
      <Grid item xs={12} className={classes.root} style={finalHeaderStyle}>
        <header id="header" className={clsx(classes.header, headerClass)} style={headerStyle}>
          <Grid container spacing={0} alignItems="center" justify="space-around">
            <Grid item xs={12} md={4} lg={4} className={classes.headerLogo}>
              <div className={classes.logo} onClick={this._gotoHome}></div>
            </Grid>
            <Grid item xs={12} md={8} lg={8} className={classes.headerMenu}>
              <HeaderMenu
                menuSize={menuSize}
                style={{ whiteSpace: 'nowrap' }}
                current={current}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                $$menu={$$menu}
              />
            {/*          <If condition={isLogginIn}>
                <DialogPopinButton
                  trigger={Button}
                  triggerProps={{
                    className: 'right',
                    label: 'Mon Compte',
                    children: 'Mon Compte',
                  }}
                  onOpened={this._setIsLogginIn}
                  popinTitle={undefined}
                  popinContent={RegistrationForm}
                  popinContentProps={{
                    onFormComplete: this._onFormComplete,
                    closeOnComplete: true,
                    showRecap: true,
                  }}
                  openOnMount={false}
                />
              </If>*/}
              <If
                condition={
                  isLogginIn !== true &&
                  (userRole === 'member' ||
                    userRole === 'admin' ||
                    userRole === 'speaker' ||
                    userRole === 'staff')
                }
              >
                <Button
                  onClick={this.handleToggle}
                  endIcon={<IconArrow />}
                  buttonRef={(node) => {
                    this.anchorEl = node;
                  }}
                  aria-owns={open ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  style={{ visibility: open === true ? 'hidden' : 'visible' }}
                  className={classes.buttonMyAccount}
                >
                  {$$user.get('email')}
                </Button>
                <Popper
                  open={open}
                  anchorEl={this.anchorEl}
                  transition
                  disablePortal
                  style={{ zIndex: 999 }}
                  placement={'bottom-start'}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} id="menu-list-grow">
                      <Paper classes={{ root: classes.profileWrapper }}>
                        <ClickAwayListener onClickAway={this.handleClose}>
                          <Box className={classes.padding}>
                            <BlockButton
                              className={classes.profileMenu}
                              lowerCase={true}
                              label={
                                <span>
                                  MON COMPTE
                                  <IconArrow
                                    style={{
                                      verticalAlign: 'middle',
                                      marginTop: '-2px',
                                    }}
                                  />
                                </span>
                              }
                              size="small"
                              variant="regular"
                              onClick={this.handleToggle}
                              aria-owns={open ? 'menu-list-grow' : undefined}
                              aria-haspopup="true"
                              style={{ borderRadius: '0' }}
                            />
                            <MenuList>
                              {$$profileMenu
                                .map((p, pIdx) => {
                                  if (p.get('target') === '_blank') {
                                    return (
                                      <MenuItem
                                        key={'pm_' + pIdx}
                                        onClick={(e) => {
                                          window.open(p.get('url'));
                                        }}
                                        classes={{
                                          root: classes.profileButton,
                                        }}
                                      >
                                        {p.get('title')}
                                      </MenuItem>
                                    );
                                  } else {
                                    return (
                                      <MenuItem
                                        key={'pm_' + pIdx}
                                        onClick={(e) => {
                                          this.handleClose(e, p.get('url'));
                                        }}
                                        classes={{
                                          root: classes.profileButton,
                                        }}
                                      >
                                        {p.get('title')}
                                      </MenuItem>
                                    );
                                  }
                                })
                                .toArray()}
                            </MenuList>
                          </Box>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </If>
            </Grid>
          </Grid>
          <If condition={headerTitle !== undefined}>
            <Grid item xs={12}>
              <Typography variant="h1">{headerTitle}</Typography>
            </Grid>
          </If>
          <If condition={headerContent !== undefined}>
            <Box className={classes.headerContent} p={2}>
              {headerContent}
            </Box>
          </If>
        </header>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    // userRole: getCurrentUserRole(state),
    // userSubRole: getCurrentUserSubRole(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onLoggedIn: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withStyles(styles)(
  withRouter(withWidth()(connect(mapStateToProps, mapDispatchToProps)(Header))),
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx